import { Injectable } from "@angular/core";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { firstValueFrom, from, Observable } from "rxjs";
import { User } from "@app/core/user/domain/user";
import { UserRepo } from "@app/core/user/domain/repositories/user.repo";
import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";

@Injectable({
  providedIn: "root",
})
export class GetUserProfileUseCase {
  constructor(
    private tokenRepo: TokenRepo,
    private userRepo: UserRepo
  ) {}

  execute(): Observable<User> {
    return from(this.getUserProfile());
  }

  private async getUserProfile(): Promise<User> {
    // Take the temporal token if it exists, otherwise take the normal token
    const token = this.tokenRepo.getTemporal() ?? this.tokenRepo.get();
    if (token == null) {
      //If the token is null, it means that the user has not logged before or the user has logged out
      throw new MissingCredentialsError();
    }
    return firstValueFrom(this.userRepo.get(token));
  }
}
